import { supabase } from '../lib/supabase'

export interface Vibe {
  id: string
  name: string
  description?: string | null
  emoji?: string | null
  created_at?: string
  updated_at?: string
}

// Demo data for when Supabase is not configured
const demoVibes: Vibe[] = [
  {
    id: '1',
    name: 'Romantic',
    description: 'Perfect for couples and intimate dining',
    emoji: '💕',
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: '2',
    name: 'Casual',
    description: 'Relaxed and informal atmosphere',
    emoji: '😊',
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: '3',
    name: 'Family Friendly',
    description: 'Great for families with children',
    emoji: '👨‍👩‍👧‍👦',
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: '4',
    name: 'Party',
    description: 'Energetic and lively atmosphere',
    emoji: '🎉',
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: '5',
    name: 'Business',
    description: 'Professional setting for business meetings',
    emoji: '💼',
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  },
  {
    id: '6',
    name: 'Quiet',
    description: 'Peaceful and serene environment',
    emoji: '🤫',
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  }
]

// Check if we're in demo mode
const isDemoMode = !process.env.REACT_APP_SUPABASE_URL || 
                   process.env.REACT_APP_SUPABASE_URL === 'https://placeholder.supabase.co'

export const vibeService = {
  // Get all vibes
  async getAllVibes(): Promise<Vibe[]> {
    if (isDemoMode) {
      // Return demo data with a small delay to simulate API call
      await new Promise(resolve => setTimeout(resolve, 300))
      return [...demoVibes]
    }

    const { data, error } = await supabase
      .from('vibes')
      .select('*')
      .order('name', { ascending: true })

    if (error) {
      console.error('Supabase error fetching vibes:', error)
      throw new Error(`Failed to fetch vibes: ${error.message || JSON.stringify(error)}`)
    }

    console.log('Fetched vibes:', data?.length || 0, 'vibes')
    return data || []
  }
}

